// src/scormApi.js
import { Scorm12API, Scorm2004API } from "scorm-again";

let activeAPI = null;

/* ---------------- SCORM 1.2 ---------------- */
const scorm12 = new Scorm12API({
  autocommit: true,
  autocommitSeconds: 10,
});

window.API = scorm12;

/* ---------------- SCORM 2004 ---------------- */
const scorm2004 = new Scorm2004API({
  autocommit: true,
  autocommitSeconds: 10,
});

window.API_1484_11 = scorm2004;

/* ---------------- Helpers ---------------- */
const isCompleted = (api, version) => {
  if (version === "2004") {
    return api.cmi.completion_status === "completed";
  }

  // SCORM 1.2
  const status = api.cmi.core.lesson_status;
  return status === "passed" || status === "completed";
};

const emitProgress = (api, version) => {
  const payload =
    version === "2004"
      ? {
          version: "SCORM_2004",
          location: api.cmi.location,
          suspendData: api.cmi.suspend_data,
          progress: api.cmi.progress_measure || null,
        }
      : {
          version: "SCORM_1.2",
          location: api.cmi.core.lesson_location,
          suspendData: api.cmi.suspend_data,
        };

  window.dispatchEvent(new CustomEvent("SCORM_PROGRESS", { detail: payload }));
};

const emitCompletion = (api, version) => {
  let payload;

  if (version === "2004") {
    payload = {
      version: "SCORM_2004",
      completed: api.cmi.completion_status === "completed",
      status: api.cmi.completion_status,
      success: api.cmi.success_status,
      score: api.cmi.score?.raw || null,
      location: api.cmi.location,
      suspendData: api.cmi.suspend_data,
    };
  } else {
    const status = api.cmi.core.lesson_status;
    payload = {
      version: "SCORM_1.2",
      completed: status === "passed" || status === "completed",
      status,
      score: api.cmi.core.score?.raw || null,
      location: api.cmi.core.lesson_location,
      suspendData: api.cmi.suspend_data,
    };
  }

  window.dispatchEvent(new CustomEvent("SCORM_COMPLETED", { detail: payload }));
};

/* ---------------- Event Wiring ---------------- */
// SCORM 1.2
scorm12.on("LMSInitialize", () => {
  activeAPI = scorm12;
  console.log("SCORM 1.2 Initialized");
});

scorm12.on("LMSSetValue", () => {
  emitProgress(scorm12, "1.2");
  if (isCompleted(scorm12, "1.2")) {
    emitCompletion(scorm12, "1.2");
  }
});

scorm12.on("LMSCommit", () => {
  emitProgress(scorm12, "1.2");
});

// SCORM 2004
scorm2004.on("Initialize", () => {
  activeAPI = scorm2004;
  console.log("SCORM 2004 Initialized");
});

scorm2004.on("SetValue", () => {
  emitProgress(scorm2004, "2004");
  if (isCompleted(scorm2004, "2004")) {
    emitCompletion(scorm2004, "2004");
  }
});

scorm2004.on("Commit", () => {
  emitProgress(scorm2004, "2004");
});

/* ---------------- Export ---------------- */
export const getActiveScormApi = () => activeAPI;
export default { scorm12, scorm2004 };
